import styled from "styled-components";
import { Container } from "../../styles/Container";

export const Wrapper = styled.div`
  height: 60px;
  margin: 0 auto;

  ${Container}


  .hide{
    right: -70vw;
  }

  .show{
    right: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    fill: var(--text-color);
  }
`;

export const NavList = styled.ul`
  

  li {
    padding: 0 1rem;
    text-transform: uppercase;
    transition: all 0.3s ease-in;
  }

  @media (max-width: 576px) {
    display: none;
  }
  @media (min-width: 576px) {
    display: none;
  }
  @media (min-width: 768px) {
    display: none;
  }
  @media (min-width: 992px) {
    display: flex;
  }
  @media (min-width: 1200px) {
    display: flex;
  }
  @media (min-width: 1400px) {
    display: flex;
  }
`;

export const SideNav= styled.div`
  position: fixed;
  top: 0;
  right: -50vw;
  z-index: 1000;
  background-color: #fff;
  width: 50vw;
  height: 100vh;

  transition: all 0.1s ease-in;

  -webkit-box-shadow: -2px 0px 15px 0px rgba(0,0,0,0.75); 
  box-shadow: -2px 0px 15px 0px rgba(0,0,0,0.75);

  ul{
    margin: 5rem 2rem;
    float: right;
    text-align: right;
    li{
      margin: 1rem auto;
    }
  }

`;

export const CloseMenuBTN = styled.button`
  background-color: transparent;
  outline: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;
  margin: 2rem;
`;

export const Hamburger = styled.button`

  background-color: transparent;
  outline: none;
  border: none;
  font-size: 2rem;
  cursor: pointer;

  @media (max-width: 576px) {
    display: flex;
  }
  @media (min-width: 576px) {
    display: flex;
  }
  @media (min-width: 768px) {
    display: flex;
  }
  @media (min-width: 992px) {
    display: none;
  }
  @media (min-width: 1200px) {
    display: none;
  }
  @media (min-width: 1400px) {
    display: none;
  } 

  :hover {
      color: var(--navy-blue);
    }
`;

export const Logo = styled.img``;
